import { inject, observer } from 'mobx-react';
import StringUtil from '@/util/StringUtil';
import ReactComponent from './ReactComponent';
import { Typography } from '@mui/material';

class TableRepresentante extends ReactComponent {
    titulo(rep) {
        let representante = StringUtil.apenasPrimeiraLetraMaiuscula(rep.tipo);

        if (rep.genero && rep.genero.startsWith('F')) {
            if (representante.startsWith('Adv')) {
                return 'Advogada';
            }

            if (representante.startsWith('Procurador')) {
                return 'Procuradora';
            }
        }

        return representante ? representante : 'Representante';
    }

    render() {
        return (
            <div>
                {this.observableProps.parteRepresentante &&
                    this.observableProps.parteRepresentante.map((rep) => {
                        return (
                            rep && (
                                <span
                                    className="lista-align-left"
                                    key={this.nextKey}
                                >
                                    <Typography className="sub-titulo">{this.titulo(rep)}</Typography>
                                    <Typography className="lista-align-left">{rep.nome}</Typography>
                                </span>
                            )
                        );
                    })}
            </div>
        );
    }
}

export default inject('stores')(observer(TableRepresentante));
